import api from "../../config/api/index.js";

interface CheckOtp {
  code: string;
  mobile: string;
}
interface SetCivilData {
  firstName: string;
  lastName: string;
  nationalId: string;
  birthDate: string;
}
interface SetAddressData {
  townshipId: number;
  postalCode: string;
  address: string;
}
export interface InsertBuildingData {
  name: string;
  address: string;
  postalCode: string;
  townShipId: number;
  apartments: Array<{
    apartmentName: string;
    flats: Array<{
      floor: number;
      flatCount: number;
    }>;
  }>;
}
/**
 * اعتبارسنجی Otp
 * @param formData - (CheckOtp)
 * @returns پاسخ سرور
 */
export const CheckOtpApi = async (formData: CheckOtp): Promise<any> => {
  try {
    const response = await api.post(
      `User/ConfirmOtp?phoneNumber=${formData.mobile}&code=${formData.code}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to create ConfirmOtp:', error);
    throw error;
  }
};
// ============================================================
// تغییر رمز عبور (کاربران حقوقی و خیریه)
// ============================================================
interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
  repeatPass: string;
}

export const ChangePasswordApi = async (
  data: ChangePasswordPayload
): Promise<any> => {
  try {
      const response = await api.post(
          "customerPanel/legal/login/changePassword",
          data
      );
      return response.data;
  } catch (error: any) {
      console.error("Failed to change password:", error);
      throw error;
  }
};
/**
 * ارسال Otp
 * @param mobile - (string)
 * @returns پاسخ سرور
 */
export const SendOtpApi = async (mobile: string): Promise<any> => {
  try {
    const response = await api.get(
      `customerPanel/login/sendOtp?mobileNumber=${mobile}`
    );
    return response.data;
  } catch (error) {
    console.error('Failed to send OTP:', error);
    throw error;
  }
};

/**
 * اعتبارسنجی Otp
 * @param mobile - (string)
 * @param otpCode - (string)
 * @returns پاسخ سرور
 */
export const ValidateOtpApi = async (mobile: string, otpCode: string): Promise<any> => {
  try {
    const response = await api.get(
      `customerPanel/login/validateOTP?mobileNumber=${mobile}&otpCode=${otpCode}`
    );
    return response.data;
  } catch (error: any) {
    console.error('Failed to validate OTP:', error);
    throw error;
  }
};

/**
 * دریافت Info
 * @returns پاسخ سرور
 */
export const GetInfoApi = async (): Promise<any> => {
  try {
    const response = await api.get("customerPanel/login/info");
    return response.data;
  } catch (error: any) {
    console.error('Failed to get info:', error);
    throw error;
  }
};


/**
 * دریافت Civil Registry
 * @returns پاسخ سرور
 */
export const GetCivilRegistryApi = async (): Promise<any> => {
  try {
    const response = await api.get("customerPanel/login/getCivilRegistry");
    return response.data;
  } catch (error: any) {
    console.error('Failed to get civil registry:', error);
    throw error;
  }
};

/**
 * به‌روزرسانی Civil Registry
 * @param data - (SetCivilData)
 * @returns پاسخ سرور
 */
export const SetCivilRegistryApi = async (data: SetCivilData): Promise<any> => {
  try {
    const response = await api.post("customerPanel/building/setCivilRegistry", data);
    return response.data;
  } catch (error: any) {
    console.error('Failed to set civil registry:', error);
    throw error;
  }
};


/**
 * ایجاد Building
 * @param data - (InsertBuildingData)
 * @returns پاسخ سرور
 */
export const InsertBuildingApi = async (data: InsertBuildingData): Promise<any> => {
  try {
    const response = await api.post("customerPanel/building/insertBuilding", data);
    return response.data;
  } catch (error: any) {
    console.error('Failed to insert building:', error);
    throw error;
  }
};

/**
 * به‌روزرسانی Address First
 * @param data - (SetAddressData)
 * @returns پاسخ سرور
 */
export const SetAddressFirstApi = async (data: SetAddressData): Promise<any> => {
  try {
    const response = await api.post("shopPanel/setAddressFirst", data);
    return response.data;
  } catch (error: any) {
    console.error('Failed to set address:', error);
    throw error;
  }
};

/**
 * دریافت Provinces
 * @returns پاسخ سرور
 */
export const GetProvincesApi = async (): Promise<any> => {
  try {
    const response = await api.get("/customerPanel/data/getALlProvince");
    return response.data;
  } catch (error: any) {
    console.error('Failed to get /customerPanel/data/getALlProvince:', error);
    throw error;
  }
};

/**
 * به‌روزرسانی New Information
 * @param UserInfo - (any)
 * @returns پاسخ سرور
 */
export const SetNewInformation = async (UserInfo: any) => {
  try {
    const res = await api.post("shopPanel/updateCivil", UserInfo);
    return res.data;
  } catch (err) {
    throw err;
  }
};



interface InsertBuildingDetailData {
  area: number;
  elevatorFirstInput: {
    elevatorCount: number;
    dueDateInsurance: string;
  };
  fireInsuranceDueDate: string;
  liAbilityInsuranceDueDate: string;
}

/**
 * ایجاد Building Detail
 * @param buildingId - (number)
 * @param data - (InsertBuildingDetailData)
 * @returns پاسخ سرور
 */
export const InsertBuildingDetailApi = async (buildingId: number, data: InsertBuildingDetailData): Promise<any> => {
  try {
    const response = await api.post(
      `customerPanel/building/insertBuildingDetailFirstTime?buildingId=${buildingId}`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error('Failed to insert building detail:', error);
    throw error;
  }
};


/**
 * دریافت Apartments
 * @param buildingId - (string | number)
 * @returns پاسخ سرور
 */
export const getApartments = async (buildingId: string | number) => {
    try {
        const response = await api.get(`customerPanel/building/apartment/`, {
            params: { buildingId }
        });
        return response.data;
    } catch (error) {
        console.error("Failed to get apartments:", error);
        throw error;
    }
};

/**
 * دریافت Customer By Code
 * @param customerCode - (string)
 * @returns پاسخ سرور
 */
export const GetCustomerByCodeApi = async (customerCode: string): Promise<any> => {
  try {
    const response = await api.get(`customerPanel/login/getCustomerByCode?customerCode=${customerCode}`);
    return response.data;
  } catch (error: any) {
    console.error('Failed to get customer by code:', error);
    throw error;
  }
};

/**
 * دریافت Legal Info
 * @returns پاسخ سرور
 */
export const GetLegalInfoApi = async (): Promise<any> => {
    try {
        const response = await api.get("customerPanel/legal/login/info");
        return response.data;
    } catch (error: any) {
        console.error('Failed to get legal info:', error);
        throw error;
    }
};